import React, { createContext, useContext, useState, useCallback } from 'react';
import LeadCaptureFlow from '../components/LeadCaptureFlow';

const LeadCaptureContext = createContext(null);

export const useLeadCapture = () => {
  const ctx = useContext(LeadCaptureContext);
  if (!ctx) throw new Error('useLeadCapture must be used within LeadCaptureProvider');
  return ctx;
};

export const LeadCaptureProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [leadType, setLeadType] = useState('free_trial');
  // Optional carry-through so a page-embedded form (e.g. LeadFormSidebar) can prefill the
  // service-agreement fields and record which page the lead came from. Both default to null,
  // so every existing caller that opens the flow with no arguments is unaffected.
  const [prefill, setPrefill] = useState(null);
  const [source, setSource] = useState(null);

  const openFreeTrial = useCallback((opts = {}) => {
    setPrefill(opts.prefill || null);
    setSource(opts.source || null);
    setLeadType('free_trial');
    setIsOpen(true);
  }, []);

  const openConsultation = useCallback((opts = {}) => {
    setPrefill(opts.prefill || null);
    setSource(opts.source || null);
    setLeadType('consultation');
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    setPrefill(null);
    setSource(null);
  }, []);

  return (
    <LeadCaptureContext.Provider value={{ openFreeTrial, openConsultation }}>
      {children}
      <LeadCaptureFlow isOpen={isOpen} onClose={close} leadType={leadType} prefill={prefill} source={source} />
    </LeadCaptureContext.Provider>
  );
};
